var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _path14, _circle41, _circle42, _circle43, _path15, _circle44, _circle45, _circle46, _path16, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _path17, _path18, _path19, _path20, _path21, _circle65, _circle66, _circle67, _path22, _path23, _path24, _path25, _rect, _rect2, _path26, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _circle68, _circle69, _circle70, _circle71, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGaia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 408,
    viewBox: "0 0 410 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.16 203.928C408.16 316 317.017 406.857 204.58 406.857C92.1428 406.857 1 316 1 203.928C1 91.8571 92.1428 1 204.58 1C317.017 1 408.16 91.8571 408.16 203.928Z",
    fill: "white",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.317 261.783L235.893 230.147M271.076 195.979L255.646 210.964M235.893 230.147V203.146M235.893 230.147L242.899 223.343M242.899 223.343V195.979M242.899 223.343L255.646 210.964M255.646 210.964V173.175L264.116 164.706M254.788 253.313L264.561 243.541M269.121 238.98L264.561 243.541M264.561 243.541V238.003M264.561 232.465V238.003M264.561 238.003L258.697 232.139V225.298M301.046 192.07H311.471M342.744 186.858L337.532 192.07H325.153M325.153 192.07L336.229 180.994M325.153 192.07H311.471M311.471 192.07L329.714 173.827M327.107 223.343L360.987 189.464V165.357L364.245 162.099M388.906 137.438L371.737 154.607M371.737 154.607V147.929M371.737 154.607L364.245 162.099M371.737 141.251V147.929M371.737 147.929L375.809 143.857V133.432M364.245 162.099V147.929M362.29 210.964H375.809L384.931 201.843H399.427M291.273 130.826V152.327L310.168 171.221M311.471 180.994V162.099L298.44 149.069V137.341M304.304 143.857V146.463L316.683 158.842V175.782M333.623 136.69H349.911L376.271 110.33M299.092 102.159L311.471 89.7798M323.85 65.0217V77.4008L317.986 83.2645M317.986 83.2645V72.1885M317.986 83.2645L311.471 89.7798M311.471 89.7798V78.0523M285.41 79.3554L318.643 46.1216M265.212 103.999V79.3554M265.212 72.1885V79.3554M265.212 94.0516L258.697 87.8252V78.0523M265.212 79.3554L270.424 74.1431V65.0217M249.576 59.8095L265.212 44.8244V18.5393M218.954 10.4003V37.6575L225.469 44.1728M239.803 72.1885V58.5065L232.636 51.3396M166.18 76.0978V58.5065L172.695 51.9912M186.377 10.4003V38.3091L179.21 45.4759M179.21 45.4759V29.1877M179.21 45.4759L172.695 51.9912M172.695 51.9912V35.703M140.77 20.348V44.8244L155.755 59.8095M132.952 87.1737V62.4156M88.648 47.4305L110.8 69.5824M127.088 79.3554H120.573L110.8 69.5824M110.8 69.5824V50.0366L100.103 39.3391M82.1327 65.0217V87.1737M88.648 72.1885V83.9161L95.1633 90.4313M108.194 103.462L95.1633 90.4313M95.1633 90.4313V78.0523M101.679 185.554V166.009L114.709 152.978V129.523M107.542 136.69V149.72L101.353 155.91M95.1633 178.388V162.099L101.353 155.91M101.353 155.91V143.205M140.77 162.099L157.058 178.388V195.979L173.021 211.941M202.665 241.586L182.468 221.389M182.468 221.389V211.941M182.468 221.389L173.021 211.941M182.468 202.494V211.941M182.468 211.941L175.953 205.426V195.979M134.255 195.979L150.217 211.941H173.021M147.286 238.98V245.495L151.846 250.056M154.452 232.139V237.025M159.665 249.404L154.452 244.192V237.025M154.452 237.025L160.316 231.161V223.995M62.5869 185.554L74.9659 197.934H112.103M107.542 191.418H82.7843L78.8751 187.509M69.7537 178.388L78.8751 187.509M78.8751 187.509V175.782L74.9659 171.872M19.1599 140.173L35.8742 156.887M71.7083 216.828L44.9956 190.115V166.009L35.8742 156.887M9.08356 201.191H18.9345L28.7074 210.964H50.8594M35.8742 156.887V148.743M35.8742 140.599V148.743M35.8742 148.743L29.3589 142.228V133.432M41.738 162.099V146.463M31.7729 113.043L55.4201 136.69H74.9659M225.469 44.1728V28.5361M225.469 44.1728L232.636 51.3396M232.636 51.3396V35.703",
    stroke: "#342E6F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.665 407.074V352.997V305.436M202.665 188.812V216.177M147.285 102.485L119.921 72.1888V32.5567M202.665 216.177L218.954 199.888V187.509M202.665 216.177V287.193M284.758 31.2002V87.1739L265.011 104.452M159.664 81.9617L155.755 78.0525V18.5394M250.227 80.4866V19.4438M202.665 305.436V287.193M202.665 305.436L224.817 283.284L233.939 274.163L255.439 252.662H272.379L295.834 229.207M392.912 179.691L362.29 210.313L349.911 222.692H326.13H302.349L295.834 229.207M295.834 229.207V195.979L333.623 158.19V117.144L358.158 92.6086M202.665 287.193L186.377 270.905L181.816 266.344L176.604 261.132L164.877 249.404H138.816L112.103 222.692M15.866 175.32L56.723 216.177H105.588L112.103 222.692M112.103 222.692V195.979L74.3142 158.19V121.705L47.97 95.3607M145.982 104.114L98.4208 102.485L67.8314 71.8954M339.959 70.0867L307.561 102.485H292.576L270.424 124.637",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.119 14.0329C160.119 16.2982 158.026 18.3967 155.103 18.3967C152.181 18.3967 150.088 16.2982 150.088 14.0329C150.088 11.7677 152.181 9.66919 155.103 9.66919C158.026 9.66919 160.119 11.7677 160.119 14.0329Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.242 13.8319C255.242 16.4705 252.843 18.8472 249.575 18.8472C246.308 18.8472 243.909 16.4705 243.909 13.8319C243.909 11.1934 246.308 8.81664 249.575 8.81664C252.843 8.81664 255.242 11.1934 255.242 13.8319Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.506 25.9573C290.506 28.5958 288.106 30.9726 284.839 30.9726C281.571 30.9726 279.172 28.5958 279.172 25.9573C279.172 23.3188 281.571 20.942 284.839 20.942C288.106 20.942 290.506 23.3188 290.506 25.9573Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M348.383 65.7484C348.383 68.387 345.984 70.7637 342.716 70.7637C339.449 70.7637 337.05 68.387 337.05 65.7484C337.05 63.1099 339.449 60.7332 342.716 60.7332C345.984 60.7332 348.383 63.1099 348.383 65.7484Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M367.374 88.3576C367.374 90.9961 364.975 93.3729 361.707 93.3729C358.44 93.3729 356.041 90.9961 356.041 88.3576C356.041 85.719 358.44 83.3423 361.707 83.3423C364.975 83.3423 367.374 85.719 367.374 88.3576Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.836 175.523C401.836 178.162 399.437 180.539 396.169 180.539C392.902 180.539 390.502 178.162 390.502 175.523C390.502 172.885 392.902 170.508 396.169 170.508C399.437 170.508 401.836 172.885 401.836 175.523Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4799 227.904C15.4799 230.542 13.0805 232.919 9.81311 232.919C6.54568 232.919 4.1463 230.542 4.1463 227.904C4.1463 225.265 6.54568 222.889 9.81311 222.889C13.0805 222.889 15.4799 225.265 15.4799 227.904Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M404.452 229.434C404.452 232.073 402.053 234.449 398.785 234.449C395.518 234.449 393.118 232.073 393.118 229.434C393.118 226.795 395.518 224.419 398.785 224.419C402.053 224.419 404.452 226.795 404.452 229.434Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2997 170.652C18.2997 173.291 15.9004 175.668 12.6329 175.668C9.36551 175.668 6.96613 173.291 6.96613 170.652C6.96613 168.014 9.36551 165.637 12.6329 165.637C15.9004 165.637 18.2997 168.014 18.2997 170.652Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8559 91.0706C50.8559 93.7091 48.4566 96.0859 45.1891 96.0859C41.9217 96.0859 39.5223 93.7091 39.5223 91.0706C39.5223 88.432 41.9217 86.0553 45.1891 86.0553C48.4566 86.0553 50.8559 88.432 50.8559 91.0706Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8471 68.4623C69.8471 71.1008 67.4477 73.4776 64.1802 73.4776C60.9128 73.4776 58.5134 71.1008 58.5134 68.4623C58.5134 65.8238 60.9128 63.447 64.1802 63.447C67.4477 63.447 69.8471 65.8238 69.8471 68.4623Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.82 27.7676C126.82 30.4061 124.421 32.7829 121.153 32.7829C117.886 32.7829 115.487 30.4061 115.487 27.7676C115.487 25.1291 117.886 22.7523 121.153 22.7523C124.421 22.7523 126.82 25.1291 126.82 27.7676Z",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7069,
    cy: 130.174,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1748,
    cy: 110.168,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.601,
    cy: 137.3,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7377,
    cy: 143.205,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5143,
    cy: 137.3,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75762,
    cy: 201.507,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4964,
    cy: 230.446,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6477,
    cy: 239.63,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4354,
    cy: 225.298,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.9803,
    cy: 183.599,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7988,
    cy: 175.781,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.011,
    cy: 169.266,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 140.6,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.194,
    cy: 134.082,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.164,
    cy: 160.145,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.649,
    cy: 194.024,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.953,
    cy: 192.721,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.468,
    cy: 199.236,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.316,
    cy: 221.388,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.286,
    cy: 306.087,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.348,
    cy: 276.116,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.831,
    cy: 272.208,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.406,
    cy: 260.479,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.892,
    cy: 265.692,
    r: 2.10611,
    stroke: "#342E6F"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.257,
    cy: 306.087,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.469,
    cy: 260.479,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.801,
    cy: 229.206,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.285,
    cy: 235.721,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.012,
    cy: 238.328,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.224,
    cy: 243.54,
    r: 2.10611,
    stroke: "#342E6F"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.891,
    cy: 243.54,
    r: 2.10611,
    stroke: "#342E6F"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.893,
    cy: 199.236,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.408,
    cy: 192.721,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.682,
    cy: 194.024,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.348,
    cy: 222.691,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.56,
    cy: 229.206,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.076,
    cy: 237.025,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.35,
    cy: 184.903,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.32,
    cy: 171.872,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.955,
    cy: 140.6,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.44,
    cy: 134.082,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.925,
    cy: 127.567,
    r: 3.40917,
    stroke: "#342E6F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M381.754 107.458C381.754 109.34 380.228 110.867 378.345 110.867C376.462 110.867 374.936 109.34 374.936 107.458C374.936 105.575 376.462 104.048 378.345 104.048C380.228 104.048 381.754 105.575 381.754 107.458Z",
    stroke: "#342E6F"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.47,
    cy: 74.1431,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.986,
    cy: 68.9297,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.085,
    cy: 61.3348,
    r: 3.40917,
    stroke: "#342E6F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324.781 44.1528C324.781 46.0357 323.255 47.562 321.372 47.562C319.489 47.562 317.963 46.0357 317.963 44.1528C317.963 42.27 319.489 40.7437 321.372 40.7437C323.255 40.7437 324.781 42.27 324.781 44.1528Z",
    stroke: "#342E6F"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.729,
    cy: 61.3348,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.56,
    cy: 68.9297,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.133,
    cy: 75.0595,
    r: 2.66519,
    stroke: "#342E6F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M268.712 15.2136C268.712 17.0964 267.186 18.6227 265.303 18.6227C263.42 18.6227 261.894 17.0964 261.894 15.2136C261.894 13.3307 263.42 11.8044 265.303 11.8044C267.186 11.8044 268.712 13.3307 268.712 15.2136Z",
    stroke: "#342E6F"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.512,
    cy: 25.1615,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.287,
    cy: 32.4444,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.182,
    cy: 7.07372,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.626,
    cy: 7.07372,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.487,
    cy: 26.0651,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.269,
    cy: 58.6219,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.043,
    cy: 32.4444,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.504,
    cy: 17.0232,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.0003,
    cy: 36.9184,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.2443,
    cy: 45.0569,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6477,
    cy: 68.9297,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1629,
    cy: 74.1431,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1327,
    cy: 61.1123,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.593,
    cy: 144.507,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.206,
    cy: 138.204,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.32,
    cy: 130.174,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.006,
    cy: 134.586,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 402.685,
    cy: 201.842,
    r: 3.40917,
    stroke: "#342E6F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.79 229.206C361.79 231.089 360.263 232.615 358.381 232.615C356.498 232.615 354.971 231.089 354.971 229.206C354.971 227.323 356.498 225.797 358.381 225.797C360.263 225.797 361.79 227.323 361.79 229.206Z",
    stroke: "#342E6F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.244 240.935C342.244 242.818 340.718 244.344 338.835 244.344C336.952 244.344 335.426 242.818 335.426 240.935C335.426 239.052 336.952 237.526 338.835 237.526C340.718 237.526 342.244 239.052 342.244 240.935Z",
    stroke: "#342E6F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M334.425 250.056C334.425 251.939 332.899 253.465 331.016 253.465C329.133 253.465 327.607 251.939 327.607 250.056C327.607 248.173 329.133 246.647 331.016 246.647C332.899 246.647 334.425 248.173 334.425 250.056Z",
    stroke: "#342E6F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.698 233.116C322.698 234.999 321.171 236.525 319.289 236.525C317.406 236.525 315.879 234.999 315.879 233.116C315.879 231.233 317.406 229.707 319.289 229.707C321.171 229.707 322.698 231.233 322.698 233.116Z",
    stroke: "#342E6F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M296.637 253.964C296.637 255.847 295.11 257.374 293.227 257.374C291.345 257.374 289.818 255.847 289.818 253.964C289.818 252.082 291.345 250.555 293.227 250.555C295.11 250.555 296.637 252.082 296.637 253.964Z",
    stroke: "#342E6F"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.864,
    cy: 162.751,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.835,
    cy: 178.387,
    r: 3.40917,
    stroke: "#342E6F"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.709,
    cy: 126.265,
    r: 3.40917,
    stroke: "#342E6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M215.044 407.725V335.406L234.886 319.118M190.286 407.725V335.406L173.998 319.118M14.3737 231.65L28.5444 245.821H45.3213L63.2383 263.738H76.9204H118.618L141.422 286.541L156.407 301.526L164.225 309.345L173.998 319.118M396.14 233.772L370.108 263.738H340.464H302.349L234.886 319.118M173.998 319.118V407.725M234.886 319.118V363.422V407.725",
    stroke: "#342E6F",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.451 263.086V259.177L107.542 255.268V245.495M115.36 263.086V257.222M115.36 257.222L121.224 251.359V246.146M115.36 257.222V241.586M357.077 232.464L351.214 238.328V263.086M338.183 264.389V244.192M331.016 264.389V253.313M321.895 263.086L313.751 254.942M316.682 235.722L305.607 246.798L313.751 254.942M313.751 254.942H295.834M88.6476 242.889V263.086L73.3366 247.775M58.0257 232.464L73.3366 247.775M73.3366 247.775V235.722L81.155 227.904M157.058 263.738V283.935M157.058 283.935L149.891 276.768V268.298M157.058 283.935V293.056M157.058 301.526V293.056M157.058 293.056L166.831 283.283V275.465M188.331 309.345L182.468 315.208V326.936M221.559 309.345L226.12 313.905V325.633M258.696 279.374V292.405M258.696 299.572V292.405M258.696 292.405L279.545 271.556L271.076 263.086",
    stroke: "#342E6F",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M268.533 124.799C268.533 159.458 240.436 187.555 205.777 187.555C171.118 187.555 143.021 159.458 143.021 124.799C143.021 90.1397 171.118 62.043 205.777 62.043C240.436 62.043 268.533 90.1397 268.533 124.799Z",
    fill: "white",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.967 132.649V152.931C176.478 153.555 175.421 151.918 175.386 149.811C175.126 134.21 174.762 102.226 175.386 99.1061C176.01 95.9858 178.767 95.2057 180.067 95.2057H197.228V127.969H216.73M187.867 132.649V152.931H193.328V144.351M210.49 104.567V95.2057C212.83 95.2057 219.383 95.2057 226.871 95.2057C234.36 95.2057 233.112 99.1061 233.112 101.446C232.852 114.188 233.112 141.04 233.112 146.691C233.112 150.591 230.772 153.191 229.212 152.931H197.228V144.351M206.589 104.567V95.2057H200.349V124.849H216.73",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 185.497,
    y: 81.134,
    width: 4.74061,
    height: 7.86092,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202.659,
    y: 81.134,
    width: 4.74061,
    height: 7.86092,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M216.701 81.134H221.441V88.995H216.701V81.134Z",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185.497,
    y: 159.143,
    width: 4.74061,
    height: 7.86092,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202.659,
    y: 159.143,
    width: 4.74061,
    height: 7.86092,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 218.628,
    y: 159.51,
    width: 4.74061,
    height: 7.86092,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 247.964,
    y: 106.097,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 247.964 106.097)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 247.964,
    y: 121.698,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 247.964 121.698)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 247.964,
    y: 138.86,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 247.964 138.86)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 169.956,
    y: 106.097,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 169.956 106.097)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 169.956,
    y: 121.698,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 169.956 121.698)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 169.956,
    y: 138.86,
    width: 4.74061,
    height: 7.86092,
    transform: "rotate(90 169.956 138.86)",
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.527,
    cy: 126.408,
    r: 6.27069,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.971,
    cy: 126.408,
    r: 6.27069,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.888,
    cy: 140.45,
    r: 4.71054,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.93,
    cy: 109.247,
    r: 4.71054,
    stroke: "#342E6F",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 204.62,
    y1: 4.06952,
    x2: 204.62,
    y2: 411.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0757479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4124,
    stopColor: "#674DA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 205.777,
    y1: 61.043,
    x2: 205.777,
    y2: 188.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127832,
    stopColor: "#342E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523673,
    stopColor: "#342E6F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGaia);
export default __webpack_public_path__ + "static/media/logoGaia.223865e4452450b5390ac4eb37630f25.svg";
export { ForwardRef as ReactComponent };